import Clipboard from 'clipboard'

up.compiler('.clippy', function(trigger, data) {
  const clipboard = new Clipboard(trigger, {
    text: function(trigger) {
      return data.text
    },
  })

  return function() {
    clipboard.destroy()
  }

})
